import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import Insights from '../components/Insights'

import { actionCreators } from '../actions'

const mapStateToProps = (state) => ({
  customer: state.customer,
  orderForm: state.order.orderForm,
  openCart: state.customer.openCart,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(actionCreators, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Insights)
